// Central feature flags. Flip a value to show/hide a whole feature across the app.
//
// AUDIOBOOKS_ENABLED: master switch for the AI narration + audiobook system
// (per-chapter NarrationBar, full-book audiobook export, the public audiobook
// player/discover/library pages, and all landing-page audiobook sections).
// Hidden for now while we evaluate ElevenReader as the listening platform.
// Set back to true to bring everything back exactly as it was.
export const AUDIOBOOKS_ENABLED = false;
